import "./Header.css";
import "react-modern-drawer/dist/index.css";
import Logo from "../../assets/logo.png";
import Menu from "../../assets/Menu.svg";
import Drawer from "react-modern-drawer";
import CloseIcon from "../../assets/close.svg";
import { useState, useEffect, useRef } from "react";
import NavButton from "../NavButton/NavButton";
import ComponentIcon from "../../assets/ComponentIcon.png";
import ScanIcon from "../../assets/ScanIcon.png";
import SDKIcon from "../../assets/SDKIcon.png";
import UIIcon from "../../assets/UIIcon.png";
import MSCPIcon from "../../assets/MSCPIcon.png";
import EIP7654Icon from "../../assets/EIP7654Icon.png";
import EIP7566Icon from "../../assets/EIP7566Icon.png";
function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const onchainStackMenu = [
    {
      text: "Ame Component",
      icon: ComponentIcon,
      href: "https://github.com/AmeNetwork/ame-component",
    },
    {
      text: "Ame SDK",
      icon: SDKIcon,
      href: "https://github.com/AmeNetwork/ame-sdk",
    },
    {
      text: "Ame Scan",
      icon: ScanIcon,
      href: "https://scan.ame.network/",
    },
    {
      text: "Ame UI",
      icon: UIIcon,
      href: "https://github.com/AmeNetwork/ame-ui",
    },
  ];
  const protocolsMenu = [
    {
      text: "EIP-7654",
      icon: EIP7654Icon,
      href: "https://eips.ethereum.org/EIPS/eip-7654",
    },
    {
      text: "EIP-7566",
      icon: EIP7566Icon,
      href: "https://eips.ethereum.org/EIPS/eip-7566",
    },
    {
      text: "MSCP",
      icon: MSCPIcon,
      href: "https://github.com/AmeNetwork/Model-Smart-Contract-Protocol",
    },
  ];
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const navScroll = (nav) => {
    const element = document.getElementById(nav);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [scrolledDown, setScrolledDown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 50) {
        setScrolledDown(true);
      } else if (currentScrollY <= 10) {
        setScrolledDown(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <div className="HeaderBg">
        <div className={scrolledDown ? "HeaderScroll" : "Header"}>
          <img src={Logo} width={140} />
          <ul className="Nav">
            <li>
              <NavButton
                title="Onchain Stack"
                list={onchainStackMenu}
              />
            </li>

            <li>
              <NavButton
                title="Protocols"
                list={protocolsMenu}
              />
            </li>

            <li className="NavLink">
              <a href="https://github.com/AmeNetwork/aser" target="_blank">
                Aser Agent
              </a>
            </li>
            <li className="NavLink">
              <a href="https://docs.ame.network/" target="_blank">
                Docs
              </a>
            </li>
          </ul>

          <div className="MenuButton" onClick={toggleDrawer}>
            <img src={Menu} width={30} />
          </div>
        </div>
      </div>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="right"
        size="80%"
        overlayOpacity={0.8}
      >
        <div className="Menus">
          <div className="MenuHeader"></div>
          <ul className="MenuItems">
            <li
              onClick={() => {
                setIsOpen(false);
                navScroll("onchainstack");
              }}
            >
              <p>Onchain Stack</p>
              
            </li>

            <li
              onClick={() => {
                setIsOpen(false);
                navScroll("protocols");
              }}
            >
              Protocols
            </li>

            <li
              onClick={() => {
                setIsOpen(false);
                navScroll("agent");
              }}
            >
              Aser Agent
            </li>
            <li>
              <a href="https://docs.ame.network/" target="_blank">
                Docs
              </a>
            </li>
          </ul>
          <div className="CloseMenu" onClick={toggleDrawer}>
            <img src={CloseIcon} width="100%" />
          </div>
        </div>
        <div className="MenuBox"></div>
      </Drawer>
    </div>
  );
}

export default Header;
